import React from "react"
import {
  CardContainer,
  ContentContainer,
  PlatformContainer,
  OtherPlatformContainer,
  FocusCardContainer,
  ListContainer,
  ListItemContainer,
  CtaButton,
  CrossIcon,
  TickIcon,
} from "./comparison-card.styles"
import dataLayerHelper from "../../helpers/datalayer.helper"
import createAndformatBulletArr from "../../helpers/bulletHtml.helper"
const ComparisonCard = ({ data, order, priceData, ctaHref = "/academy", buttonText }) => {
  const points = createAndformatBulletArr(data).slice(1)
  const handleClick = () => {
    dataLayerHelper({
      event: "homePageComparisonCTA",
      action: "CTA Button Click",
    })
  }
  return order === 1 ? (
    <FocusCardContainer className="ztm-card">
      <PlatformContainer order={order}>
        <h3>{priceData[order].text}</h3>
        <div>{priceData[order].price}</div>
      </PlatformContainer>
      <ContentContainer order={order}>
        <ListContainer>
          {points.map((ele, id) => (
            <li key={id}>
              <TickIcon />
              <ListItemContainer
                dangerouslySetInnerHTML={{
                  __html: ele,
                }}
              />
            </li>
          ))}
        </ListContainer>

        <CtaButton internal large href={ctaHref} onClick={handleClick}>
          {buttonText ? buttonText : "JOIN ZERO TO MASTERY"}
        </CtaButton>
      </ContentContainer>
    </FocusCardContainer>
  ) : (
    <CardContainer>
      <OtherPlatformContainer order={order}>
        <h3>{priceData[order].text}</h3>
        <div>{priceData[order].price}</div>
      </OtherPlatformContainer>
      <ContentContainer order={order}>
        <ListContainer>
          {points.map((ele) => (
            <li>
              <CrossIcon />
              <ListItemContainer
                dangerouslySetInnerHTML={{
                  __html: ele,
                }}
              />
            </li>
          ))}
        </ListContainer>
      </ContentContainer>
    </CardContainer>
  )
}

export default ComparisonCard
